export default __webpack_public_path__ + "static/media/ico-dice.7a6102af.svg";